/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, {Component} from 'react';
import PropTypes from "prop-types";
import ComponentDRV from "./ComponentPageComponents/ComponentDRV";
import ComponentOM from "./ComponentPageComponents/ComponentOM";
import Chapters from "./ComponentPageComponents/Chapters";

import {AddContentComponent} from "./ComponentPageComponents/AddContentComponent";
import {LoaderPage} from "./ComponentPageComponents/loaderPage";


export default class BookComponent extends Component {

    addToCollection = (resourcesIds, insertPosition) => {
        const payload = {
            insertAfter: insertPosition,
            resourceIds: resourcesIds,
            currency: this.props.activeCollection.geo.code,
            priceType: this.props.activeCollection.collectionType
        };
        this.props.addResourcesToCollection(this.props.activeCollection.collectionId, this.state.selectedChapterId, payload);
        setTimeout(()=>{this.hideAddContentComponent();},2000);
    };
    showAddContentComponent = (chapterId, selectedChapterResources) => {
        this.setState({AddContentVisibility: true, selectedChapterId: chapterId, selectedChapterResources: selectedChapterResources});

    };
    hideAddContentComponent = () => {
        this.setState({AddContentVisibility: false, selectedChapterId: '', selectedChapterResources: []});
    };

    constructor() {
        super();
        this.state = {
            AddContentVisibility: false,
            selectedChapterId: '',
            selectedChapterResources: []
        };
    }

    //need to recheck these Proptypes
    static get propTypes() {
        return {
            activeCollection: PropTypes.object,
            addResourcesToCollection: PropTypes.func,
            cbeContentSearch: PropTypes.func,
            resourceSearchResult: PropTypes.object,
            resetSearchData: PropTypes.func,
            collectionToc: PropTypes.array,
            resetCollection: PropTypes.func,
            getPCSLogs: PropTypes.func,
            router: PropTypes.object,
            title: PropTypes.string,
            sendToPCS: PropTypes.func,
            guardDirtySetActive: PropTypes.func,
            guardDirtyIsActive: PropTypes.bool,
            children: PropTypes.node,
            getAccessCodeInfo: PropTypes.func,
            saveAccessCodeSetup: PropTypes.func,
            updateCollectionChapterInfo: PropTypes.func,
            updateCollectionChapters: PropTypes.func,
            match: PropTypes.object.isRequired,
            deleteInstance: PropTypes.func.isRequired,
            removePart: PropTypes.func.isRequired,
            updateTitle: PropTypes.func.isRequired,
            createPart: PropTypes.func.isRequired,
            bookBuildContent:PropTypes.object.isRequired,
            getBookBuildContent: PropTypes.func.isRequired,
            uploadFile: PropTypes.func.isRequired,
            resourceUploadData: PropTypes.object.isRequired,
            updateAdditionalResourceInfo: PropTypes.func.isRequired,
            resourceUploadSuccessDataEdit: PropTypes.func.isRequired,
            uploadContent: PropTypes.func.isRequired,
            clearAdditionalInfo: PropTypes.func.isRequired,
            closeModal: PropTypes.func.isRequired,
            getResource: PropTypes.func.isRequired,
            clearResource: PropTypes.func.isRequired
        };
    }

    componentDidMount(){
        this.props.getBookBuildContent(this.props.match.params.collId);
    }

    render() {
        const {activeCollection } = this.props; 
        return (
            this.props.bookBuildContent && this.props.bookBuildContent.rebuildBookComplete ?
                <div>
                    <Chapters
                        updateTitle={this.props.updateTitle}
                        updateCollectionChapters={this.props.updateCollectionChapters}
                        updateCollectionChapterInfo={this.props.updateCollectionChapterInfo}
                        removePart={this.props.removePart}
                        showAddContentComponent={this.showAddContentComponent}
                        activeCollection={activeCollection}
                        deleteInstance={this.props.deleteInstance}
                        createPart={this.props.createPart}
                        uploadFile={this.props.uploadFile}
                        resourceUploadData={this.props.resourceUploadData}
                        updateAdditionalResourceInfo={this.props.updateAdditionalResourceInfo}
                        resourceUploadSuccessDataEdit={this.props.resourceUploadSuccessDataEdit}
                        uploadContent={this.props.uploadContent}
                        clearAdditionalInfo={this.props.clearAdditionalInfo}
                        closeModal={this.props.closeModal}
                        getResource={this.props.getResource}
                        clearResource={this.props.clearResource}/>

                    <ComponentDRV
                        chapters={this.props.activeCollection.chapters}
                        collectionId={this.props.match.params.collId}
                        getDRVs={this.props.getDRVs}/>
                    {this.props.activeCollection.resourceIds ?
                        <ComponentOM
                            collectionId={this.props.match.params.collId}
                            resourceIds={this.props.activeCollection.resourceIds}
                            getOMs={this.props.getOMs}/>
                        : null}

                    {this.state.AddContentVisibility && <AddContentComponent
                        selectedChapterResources={this.state.selectedChapterResources}
                        addToCollection={this.addToCollection}
                        resetSearchData={this.props.resetSearchData}
                        resourceSearchResult={this.props.resourceSearchResult}
                        closeModal={this.hideAddContentComponent}
                        activeCollection={this.props.activeCollection}
                        cbeContentSearch={this.props.cbeContentSearch}
                        fetchPDFURL={this.props.fetchPDFURL}
                        resetPDFURL={this.props.resetPDFURL}
                    />
                    }
                </div> : <LoaderPage/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookComponent.js